'use strict';

// eslint-disable-next-line no-multi-assign
window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('base/components/menu'));
    processInclude(require('./components/menu'));
    processInclude(require('./search/searchBar'));
    processInclude(require('base/components/cookie'));
    processInclude(require('./components/consentTracking'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./components/quickLogin'));
    processInclude(require('./components/newsletterPopup'));
    // processInclude(require('./productTile'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('base/components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./components/mobileMenu'));
    // processInclude(require('./cart/miniCart'));
    processInclude(require('./login/login'));
    processInclude(require('slick-carousel'));
    processInclude(require('./slider'));
    processInclude(require('./mccollect/mcCollect'));
});

require('base/thirdParty/bootstrap');
require('base/components/spinner');
